import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationData } from '../../../../services/notification.service';
import {
  PurchaseOption,
  WayPurchaseSelectionCardVm,
  WayPurchaseSelectionDisplayVm,
  WayShopPurchaseOption,
} from '../../models/way-purchase.models';
import { buildWayPurchaseSelectionDisplayVm } from '../../utils/way-purchase-selection-display.util';
import { shouldShowWayPurchaseSelectionLayout } from '../../utils/way-purchase-layout.util';
import { WayPurchaseSelectionCardComponent } from '../way-purchase-selection-card/way-purchase-selection-card.component';

@Component({
  selector: 'app-way-purchase-selection-layout',
  standalone: true,
  imports: [CommonModule, WayPurchaseSelectionCardComponent],
  templateUrl: './way-purchase-selection-layout.component.html',
  styleUrls: ['./way-purchase-selection-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WayPurchaseSelectionLayoutComponent implements OnChanges {
  @Input() notification: NotificationData | null = null;
  @Input() canceledOrderIds = new Set<string>();
  @Input() isBusy = false;
  @Input() cardErrors: Record<string, string> = {};
  @Input() activeCardId: string | null = null;
  @Input() cardPlateInputs: Record<string, string> = {};
  @Input() plateInputDisabled = false;

  @Output() useOption = new EventEmitter<PurchaseOption>();
  @Output() cancelShopOption = new EventEmitter<WayShopPurchaseOption>();
  @Output() cardPlateInputChange = new EventEmitter<{ cardId: string; value: string }>();

  displayVm: WayPurchaseSelectionDisplayVm | null = null;
  isVisible = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notification'] || changes['canceledOrderIds']) {
      this.isVisible = shouldShowWayPurchaseSelectionLayout(this.notification);
      this.displayVm = this.isVisible
        ? buildWayPurchaseSelectionDisplayVm(this.notification?.data, this.canceledOrderIds)
        : null;
    }
  }

  onCardPlateInput(cardId: string, value: string): void {
    this.cardPlateInputChange.emit({ cardId, value });
  }

  cardErrorFor(card: WayPurchaseSelectionCardVm): string {
    return this.cardErrors[card.id] ?? '';
  }

  trackByCardId(_index: number, card: WayPurchaseSelectionCardVm): string {
    return card.id;
  }

  onUse(card: WayPurchaseSelectionCardVm): void {
    this.useOption.emit(card.option);
  }

  onCancel(card: WayPurchaseSelectionCardVm): void {
    if (card.option.source !== 'shop') {
      return;
    }
    this.cancelShopOption.emit(card.option);
  }

  isCardBusy(card: WayPurchaseSelectionCardVm): boolean {
    return this.isBusy && this.activeCardId === card.id;
  }
}
